//
//
//
//
//
//
//
//
//
//
//

import { getUserInfo } from "@/utils/auth";

export default {
  data() {
    return {
      star: 0,
      avatar: "",
    };
  },
  props: {
    size: {
      type: String,
      default: "normal", // normal mini big
    },
    enable: {
      type: Boolean,
      default: true, // 是否有点击事件，默认有
    },
  },
  mounted() {
    let userInfo = getUserInfo();
    if (userInfo) {
      this.star = Number(userInfo.starLevel);
      if (userInfo.headImgUrl) {
        this.avatar = userInfo.headImgUrl;
      } else {
        this.avatar = require("../assets/avatar.png");
      }
    }
  },
  methods: {
    toUserCenter() {
      if (this.enable === true) {
        this.$router.push({
          path: "/userCenter",
        });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/CAvatar.vue